module.exports = __webpack_public_path__ + "img/suppen--white.329f9766.svg";